
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetColour as ObiLightningLightSleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-colour.js';
 
 
 

 
 export const ObiLightningLightSleetColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-colour',
   elementClass: ObiLightningLightSleetColourElement,
   events: {
     
   }
  });
 
 